// extracted by mini-css-extract-plugin
export default {"textareaContainer":"Textarea_textareaContainer__wYbRy","textareaLabel":"Textarea_textareaLabel__jJPa6","textareaElement":"Textarea_textareaElement__k9CXz"};